import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  auditUserFilterData : {},
  entities: [],
  contestReportData: {
    entities: [],
    totalCount: 0,
  },
  buyCoinReportData: {
    entities: [],
    totalCount: 0,
  },
  buyBundleReportData: {
    entities: [],
    totalCount: 0,
  },
  avatarReportData: {
    entities: [],
    totalCount: 0,
  },
  tournamentReportData: {
    entities: [],
    totalCount: 0,
  },
  paymentReportData: {
    entities: [],
    totalCount: 0,
  },
  oveallReportData: {
    entities: [],
    totalCount: 0,
  },
  businessReportData: {
    entities: [],
    totalCount: 0,
  },
  businessDReportData: {
    entities: [],
    totalCount: 0,
    reportType:"",
  },
  businessMReportData: {
    entities: [],
    totalCount: 0,
  },
  auditReportData: {
    entities: [],
    totalCount: 0,
    audits:[]
  },
  auditedContestReportData: {
    entities: [],
    totalCount: 0    
  },
  auditUserContestList: {
    entities: [],
    totalCount: 0,
    user : {},
  },
  gstReportData: {
    entities: [],
    totalCount: 0,
  },
  gstReportExportData: {
    entity: {},
  
  },
  remarkReportData: {
    entities: [],
    totalCount: 0,
    remarks:[]
  },
  levelForEdit: {},
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};
export const Slice = createSlice({

  name: "reports",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // listFetched
    ContestReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestReportData.entities = entities;
      state.contestReportData.totalCount = totalCount;
    },
    TournamentReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.tournamentReportData.entities = entities;
      state.tournamentReportData.totalCount = totalCount;
    },
    // listFetched
    PaymentReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.paymentReportData.entities = entities;
      state.paymentReportData.totalCount = totalCount;
    },
    // listFetched
    OverallReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.oveallReportData.entities = entities;
      state.oveallReportData.totalCount = totalCount;
    },
    // listFetched
    BusinessReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.businessReportData.entities = entities;
      state.businessReportData.totalCount = totalCount;
    },
    // listFetched
    BusinessDReportFetched: (state, action) => {
      const { totalCount, entities,reportType } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.businessDReportData.entities = entities;
      state.businessDReportData.totalCount = totalCount;
      state.businessDReportData.reportType = reportType;
      
    },
    // listFetched
    BusinessMReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.businessMReportData.entities = entities;
      state.businessMReportData.totalCount = totalCount;
    },
    // listFetched
    AuditUserFilterData : (state, action) => {
      const { queryParams } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.auditUserFilterData = queryParams;
    },
    AuditUserContestFetched: (state, action) => {
      const { totalCount, entities, user } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.auditUserContestList.entities = entities;
      state.auditUserContestList.totalCount = totalCount;
      state.auditUserContestList.user = user;
    },
    AuditReportFetched: (state, action) => {
      const { totalCount, entities, audits } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.auditReportData.entities = entities;
      state.auditReportData.totalCount = totalCount;
      state.auditReportData.audits = audits;
    },
    AuditedContestReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.auditedContestReportData.entities = entities;
      state.auditedContestReportData.totalCount = totalCount;
    },
    // listFetched
    RemarkReportFetched: (state, action) => {
      const { totalCount, entities, remarks } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.remarkReportData.entities = entities;
      state.remarkReportData.totalCount = totalCount;
      state.remarkReportData.remarks = remarks;
    },
    // listFetched
    BuyCoinReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.buyCoinReportData.entities = entities;
      state.buyCoinReportData.totalCount = totalCount;
    },
    // listFetched
    BuyBundleReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.buyBundleReportData.entities = entities;
      state.buyBundleReportData.totalCount = totalCount;
    },
    // listFetched
    AvatarReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.avatarReportData.entities = entities;
      state.avatarReportData.totalCount = totalCount;
    },
      // listFetched
      GSTReportFetched: (state, action) => {
        const { totalCount, entities } = action.payload;
        state.listLoading = false;
        state.error = null;
        state.gstReportData.entities = entities;
        state.gstReportData.totalCount = totalCount;
      },
        // list Export Fetched
        GSTReportExportFetched: (state, action) => {
          const { entity } = action.payload;
          state.listLoading = false;
          state.error = null;
          state.gstReportExportData.entity = entity;
          
        },
  }
});
